<!--@Deprecated use /decisioning-criteria/components/CriterionInputComponents/...-->
<template>
    <!-- PRODUCT-26110 Task 5 (INSTANCE_ATTRS_CLASS_STYLE): see
         CriterionInputComponents/CriterionEnumInput.vue -- inheritAttrs: false stops
         Vue 3 from auto-applying class/style to root. CriterionEnumCountryInput.vue
         (this directory) forwards its own $attrs (including class/style) into this
         component unchanged via h(), so this binding is also what makes class/style
         reach the DOM for that wrapper's callers too. -->
    <div class="CriterionEnumInput" :class="$attrs.class" :style="$attrs.style">
        <FormElement :label="hideTitle ? null : schema.title">
            <template v-if="schema.description" #labelHint>
                <div
                    v-tooltip="schema.description"
                    class="CriterionEnumInput__hintIcon"
                >
                    <FontAwesomeIcon :icon="faQuestionCircle" />
                </div>
            </template>
            <FormInput
                :invalid="showValidationErrors && (showError || accessed) && hasError"
                force-error-slot
                :force-action-slot="deletable"
            >
                <Dropdown
                    :options="options"
                    :selected="currentOption"
                    :disabled="rbacDisabled"
                    @input="onInput"
                    @blur="touch"
                    @focus="onFocus"
                >
                    <template v-if="$slots.dropdownPrepend" #prepend>
                        <slot name="dropdownPrepend" :current-option="currentOption" />
                    </template>
                </Dropdown>
                <template v-if="showValidationErrors && (showError || accessed) && hasError" #errorMessage>
                    {{ errorMessage }}
                </template>
                <template v-if="deletable || rbacDisabled" #actionButtons>
                    <LockInputIcon v-if="rbacDisabled" />
                    <NewButton
                        v-else-if="deletable"
                        variant="flat"
                        size="icon-sm"
                        color="secondary"
                        class="JsonSchemaForm__deleteIcon"
                        @click="$emit('delete')"
                    >
                        <EidIcon :icon-src="faXmark" alt="delete" />
                    </NewButton>
                </template>
            </FormInput>
        </FormElement>
    </div>
</template>

<script lang="ts">
    import { Component } from '@evidentid/vue-property-decorator';

    import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
    import { faXmark } from '@fortawesome/pro-light-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import Dropdown from '@evidentid/dashboard-commons/components/Dropdown/Dropdown.vue';
    import { DropdownOption } from '@evidentid/dashboard-commons/components/Dropdown/types';
    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import { FormElement, FormInput } from '@evidentid/dashboard-commons/components/Form';
    import LockInputIcon from '@evidentid/dashboard-commons/components/LockInputIcon/LockInputIcon.vue';
    import { JsonSchemaEnum } from '@evidentid/json-schema/interfaces/JsonSchema';

    import NewButton from '@/components/new-button/NewButton.vue';

    import AbstractCriterionInput from './AbstractCriterionInput';

    @Component({
        emits: [ 'delete', 'input' ],
        components: { FormInput, Dropdown, EidIcon, FontAwesomeIcon, FormElement, LockInputIcon, NewButton },
        inheritAttrs: false,
    })
    export default class CriterionEnumInput extends AbstractCriterionInput<JsonSchemaEnum, any> {
        // @Deprecated use /decisioning-criteria/components/CriterionInputComponents/...
        private faXmark = faXmark;
        private faQuestionCircle = faQuestionCircle;
        private options: DropdownOption[] = [];

        private get currentOption(): DropdownOption[] {
            // FIXME: handle duplicate values
            const option = this.options.find((option) => option.value === this.value);
            return option ? [ option ] : [];
        }

        private setEnumLabelsAndOptions(): void {
            const values = this.schema.enum || [];
            const labels = this.schema.enumLabels && this.schema.enumLabels.length > 0
                ? this.schema.enumLabels
                : null;
            this.options = labels
                ? values.map((value, i) => ({ value, label: labels[i] }))
                : values.map(this.buildOptionFromValue);
        }

        private buildOptionFromValue(value: any): DropdownOption {
            return { value, label: value };
        }

        private onInput(option: DropdownOption): void {
            this.$emit('input', option.value);
        }

        private beforeMount() {
            this.setSchemaVisible?.(this.schemaPath, true);
            this.setEnumLabelsAndOptions();
        }

        private beforeDelete() {
            this.setSchemaVisible?.(this.schemaPath, false);
        }
    }
</script>
